
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Busbookingformarriage() {



    const cardData =
    {
        keyword: 'Bus Booking for Marriage',
        heading: 'Amruta Travels: Bus Booking for Marriage',
        headingDescription: 'Amruta Travels provides complete Bus Booking for Marriage functions in Pune, including engagement ceremonies, Haldi, Mehendi, Sangeet, wedding day transportation, reception events, and family gatherings. Whether you need a single luxury coach or multiple buses for large guest groups, we help you manage transportation across multiple venues with flexible routes, experienced drivers, and comfortable buses. Our marriage transportation services ensure every guest reaches the venue safely and on time throughout your celebrations.',


        top: "Marriage Bus Booking Process with Amruta Travels",

    "topPlaces":[
{
"title":"Share Your Marriage Function Details",
"description":"Tell us your marriage date, guest count, venues, ceremony timings, pickup locations, and transportation requirements."
},
{
"title":"Get a Customized Marriage Transportation Plan",
"description":"Our team prepares the best transportation plan for your marriage ceremony, reception, Haldi, Mehendi, Sangeet, and guest movements."
},
{
"title":"Choose Suitable Buses",
"description":"Select from 25, 32, 35, 45, and 50-seater AC or Non-AC buses depending on your family size and guest list."
},
{
"title":"Reserve Your Marriage Buses",
"description":"Confirm your preferred buses early to secure availability during busy marriage seasons."
},
{
"title":"Receive Transparent Quotation",
"description":"Get a detailed quotation with vehicle details, travel schedule, pricing, and payment options without hidden charges."
},
{
"title":"Guest Pickup Planning",
"description":"We organize guest pickup schedules from homes, hotels, railway stations, airports, and marriage venues."
},
{
"title":"Transportation for Every Ceremony",
"description":"Our buses remain available for Haldi, Mehendi, Sangeet, Marriage Ceremony, Reception, and family functions according to your itinerary."
},
{
"title":"Professional Event Coordination",
"description":"Our team coordinates vehicle reporting time, routes, driver communication, and last-minute schedule updates."
},
{
"title":"Comfortable Guest Transportation",
"description":"Ensure your guests travel together comfortably and reach every marriage function safely and on time."
},
{
"title":"Dedicated Marriage Booking Support",
"description":"Our support team remains available throughout your marriage events to assist with transportation requirements whenever needed."
}
],

  "services":[
{
"name":"Marriage Ceremony Bus Booking",
"description":"Book comfortable buses for the main marriage ceremony with customized pickup schedules, guest transportation, and professional coordination."
},
{
"name":"Haldi Ceremony Bus Booking",
"description":"Arrange buses for Haldi ceremonies so family members and guests can travel together comfortably and reach the venue on time."
},
{
"name":"Mehendi Function Bus Booking",
"description":"Book dedicated buses for Mehendi functions with flexible pickup locations and convenient transportation for relatives and friends."
},
{
"name":"Sangeet Function Bus Booking",
"description":"Provide comfortable transportation for guests attending your Sangeet ceremony with AC and Non-AC bus options."
},
{
"name":"Marriage Reception Bus Booking",
"description":"Reserve buses for reception events to transport guests between hotels, homes, marriage halls, and reception venues."
},
{
"name":"Family Function Transportation",
"description":"Manage transportation for engagement ceremonies, family gatherings, and pre-wedding celebrations with reliable bus booking services."
},
{
"name":"Marriage Guest Transportation",
"description":"Ensure smooth guest transportation from airports, railway stations, hotels, and residences to every marriage function."
},
{
"name":"Multiple Venue Marriage Transportation",
"description":"Planning functions at different venues? We coordinate buses between marriage halls, banquet halls, hotels, and outdoor venues."
},
{
"name":"Destination Marriage Bus Booking",
"description":"Book buses for destination marriage celebrations in Lonavala, Mahabaleshwar, Alibaug, Nashik, Goa, and nearby locations."
},
{
"name":"Marriage Transportation Coordination",
"description":"Our team coordinates reporting time, guest pickup schedules, driver communication, and transportation planning throughout your marriage events."
},
{
"name":"Luxury Marriage Bus Booking",
"description":"Choose luxury AC buses for premium marriage transportation with comfortable seating and professional service for your guests."
},
{
"name":"Marriage Travel Support",
"description":"From your first enquiry until the final ceremony, our team provides complete transportation support for every marriage function."
}
],
  "tableData":[
["Marriage Ceremony Bus Booking","Haldi Ceremony Bus Booking"],
["Mehendi Function Bus Booking","Sangeet Function Bus Booking"],
["Marriage Reception Bus Booking","Marriage Guest Transportation"],
["Family Function Bus Booking","Multiple Venue Marriage Transportation"],
["Destination Marriage Bus Booking","Luxury Marriage Bus Booking"],
["Marriage Event Transportation","Marriage Travel Coordination"],
["Marriage Bus Booking in Pune","Marriage Transportation Services"]
],




"whychoose":[
{
"WhyChooseheading":"Complete Marriage Transportation Planning",
"WhyChoosedescription":"We help you plan transportation for every marriage function including Haldi, Mehendi, Sangeet, Marriage Ceremony, Reception, and family gatherings with proper scheduling."
},
{
"WhyChooseheading":"Transportation for Every Marriage Function",
"WhyChoosedescription":"Whether your celebration spans one day or multiple days, our buses remain available according to your marriage event itinerary."
},
{
"WhyChooseheading":"Professional Guest Coordination",
"WhyChoosedescription":"Our team coordinates guest pickup locations, reporting time, routes, and travel schedules so everyone reaches the venue comfortably."
},
{
"WhyChooseheading":"Multiple Venue Transportation",
"WhyChoosedescription":"Hosting functions at different venues? We provide smooth transportation between hotels, homes, banquet halls, marriage halls, and reception venues."
},
{
"WhyChooseheading":"Flexible Marriage Transportation",
"WhyChoosedescription":"Need last-minute route changes or additional pickup points? We provide flexible transportation planning based on your marriage schedule."
},
{
"WhyChooseheading":"Transparent Booking & Pricing",
"WhyChoosedescription":"Receive clear quotations, transparent pricing, convenient payment options, and professional support without hidden charges."
},
{
"WhyChooseheading":"Experienced Marriage Event Support",
"WhyChoosedescription":"From your first enquiry until the final ceremony, our experienced team helps manage transportation for every marriage function."
},
{
"WhyChooseheading":"Trusted Marriage Bus Booking in Pune",
"WhyChoosedescription":"Families across Pune choose Amruta Travels for reliable marriage transportation because of our professional coordination, punctual service, and customer-focused support."
}
]



























    }

const faqData = [
  {
    question: 'How can I book a bus for marriage transportation with Amruta Travels?',
    answer: 'Booking a bus for marriage transportation with Amruta Travels is easy. You can book through our website, call our support team, or visit our office. We will help you choose the right bus based on the size of your guest list and specific requirements.',
  },
  {
    question: 'What types of buses are available for marriage transportation?',
    answer: 'We offer a variety of buses for marriage transportation, including 32, 35, 45, and 50 seater options. All our buses are equipped with comfortable seating, air conditioning, and ample space for luggage, ensuring a smooth and pleasant journey for your wedding guests.',
  },
  {
    question: 'Can I book buses for multiple pickup and drop-off points for my marriage?',
    answer: 'Yes, we provide flexible routing with multiple pickup and drop-off points for your marriage. Whether it’s from the bride’s house, groom’s house, or any other venue, we’ll plan the route accordingly.',
  },
  {
    question: 'Are the buses decorated for marriage events?',
    answer: 'Yes, we can decorate the buses to match the theme of your marriage. Just inform us about your preferences, and we will make sure the buses look beautiful and match your wedding decor.',
  },
  {
    question: 'Are the buses well-maintained and sanitized for marriage events?',
    answer: 'Yes, all our buses are well-maintained and sanitized before each trip. We prioritize cleanliness and comfort to ensure your guests have a safe and pleasant journey on your special day.',
  },
  {
    question: 'How much does it cost to book a bus for a marriage?',
    answer: 'The cost of booking a bus for a marriage depends on the type of bus, travel distance, and duration. Contact us for a customized quote based on your specific requirements.',
  },
  {
    question: 'Do you provide drivers with the buses for marriage events?',
    answer: 'Yes, all bus bookings for marriage events include professional, experienced drivers who are trained to ensure safety, punctuality, and a smooth travel experience for your guests.',
  },
  {
    question: 'Can the buses be used for both the wedding ceremony and reception?',
    answer: 'Yes, our buses can be used for both the wedding ceremony and reception, transporting guests between venues comfortably and on time.',
  },
  {
    question: 'Why choose Amruta Travels for marriage bus bookings?',
    answer: 'Amruta Travels is known for reliable and professional service. Our well-maintained buses, experienced drivers, and focus on customer satisfaction make us the perfect choice for your marriage transportation needs.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Akash Rao',
    role: 'Wedding Planner, Pune',
    text: 'We booked a 45-seater bus from Amruta Travels for a wedding. The bus was clean, decorated beautifully, and the driver was polite and punctual. Our guests were very impressed with the service!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Snehal Deshpande',
    role: 'Bride, Pune',
    text: 'Amruta Travels provided a 50-seater bus for our marriage. It was on time, comfortable, and spacious enough for all the guests. The driver was professional, and the entire experience was seamless.',
    rating: 5,
  },
];







































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
{
place: "/images/keyword/1.jpg",
text: "Marriage Bus Booking in Pune"
},
{
place: "/images/keyword/2.jpg",
text: "Marriage Guest Transportation"
},
{
place: "/images/keyword/3.jpg",
text: "25 Seater Marriage Bus Booking"
},
{
place: "/images/keyword/4.jpg",
text: "32 Seater Marriage Bus Booking"
},
{
place: "/images/keyword/5.jpg",
text: "35 Seater Marriage Bus Booking"
},
{
place: "/images/keyword/6.jpg",
text: "45 Seater Marriage Bus Booking"
},
{
place: "/images/keyword/7.jpg",
text: "50 Seater Marriage Bus Booking"
},
{
place: "/images/keyword/8.jpg",
text: "Marriage Ceremony Transportation"
},
{
place: "/images/keyword/9.jpg",
text: "Family Function Bus Booking"
},
{
place: "/images/keyword/10.jpg",
text: "Wedding Bus Booking"
},
{
place: "/images/keyword/11.jpg",
text: "Bus Booking for Marriage"
},
{
place: "/images/keyword/12.jpg",
text: "Reception Bus Booking"
},
{
place: "/images/keyword/13.jpg",
text: "Marriage Event Transportation"
},
{
place: "/images/keyword/14.jpg",
text: "Mehendi Function Bus Booking"
},
{
place: "/images/keyword/15.jpg",
text: "Haldi Ceremony Bus Booking"
},
{
place: "/images/keyword/16.jpg",
text: "AC Marriage Bus Booking"
},
{
place: "/images/keyword/17.jpg",
text: "Marriage Transportation Pune"
},
{
place: "/images/keyword/18.jpg",
text: "Sangeet Function Bus Booking"
},
{
place: "/images/keyword/19.jpg",
text: "Non AC Marriage Bus Booking"
},
{
place: "/images/keyword/20.jpg",
text: "Luxury Marriage Bus Booking"
},
{
place: "/images/keyword/22.jpg",
text: "Marriage Guest Travel"
},
{
place: "/images/keyword/23.jpg",
text: "Destination Marriage Bus Booking"
},
{
place: "/images/keyword/24.jpg",
text: "Marriage Reception Transportation"
},
{
place: "/images/keyword/25.jpg",
text: "Marriage Family Transportation"
},
{
place: "/images/keyword/26.jpg",
text: "Marriage Group Transportation"
}
];


    const images = [
{
src: "/images/gallery/24.jpg",
alt: "Bus Booking for Marriage in Pune"
},
{
src: "/images/gallery/28.jpg",
alt: "Marriage Guest Transportation Bus"
},
{
src: "/images/gallery/2.jpg",
alt: "Marriage Ceremony Bus"
},
{
src: "/images/gallery/3.jpg",
alt: "Luxury Marriage Bus Booking"
},
{
src: "/images/gallery/24.jpg",
alt: "Marriage Event Transportation"
},
{
src: "/images/gallery/27.jpg",
alt: "Family Function Bus Booking"
},
{
src: "/images/gallery/29.jpg",
alt: "Marriage Reception Bus"
},
{
src: "/images/gallery/30.jpg",
alt: "Marriage Group Transportation"
},
{
src: "/images/gallery/31.jpg",
alt: "AC Marriage Bus Booking"
}
];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus Booking for Marriage",
  "image": "https://bushireinpune.com/assets/images/bus-booking-for-marriage.jpg",
  "description": "Book a bus for your marriage with Amruta Travels. We offer full bus bookings for marriage events, including outstation services, marriage party transport, and sleeper bus rentals. Convenient and affordable wedding transport for all functions in Pune and Pimpri Chinchwad.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "4398"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "50", // Adjust based on per km or flat rate for wedding bus rental
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/bus-booking-for-marriage"
  }
};




    return (
        <div>


<Helmet>
  <title>Call: +91 7353109555 | Bus Booking for Marriage | Marriage Event & Party Bus Hire in Pune | Amruta Travels</title>
  <meta 
    name="description" 
    content="Book a bus for your marriage in Pune with Amruta Travels. Full bus bookings for marriage events, outstation trips, and party transport. Rent sleeper buses and more for your wedding functions." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/11.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Busbookingformarriage;